
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="自动填充方向" fileName="autofill-direction.md" />
        <demo-block>
        <div><p>可以设置在某一个方向开启自动填充</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;el-radio-group @change=&quot;autofillTypeChang&quot; v-model=&quot;autofillType&quot;&gt;
            &lt;el-radio label=&quot;Horizontal&quot;&gt;Horizontal&lt;/el-radio&gt;
            &lt;el-radio label=&quot;Vertical&quot;&gt;Vertical&lt;/el-radio&gt;
            &lt;el-radio label=&quot;All&quot;&gt;All&lt;/el-radio&gt;
        &lt;/el-radio-group&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;ve-table
            fixed-header
            border-y
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            :cell-autofill-option=&quot;cellAutofillOption&quot;
            rowKeyFieldName=&quot;rowKey&quot;
            :rowStyleOption=&quot;rowStyleOption&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                autofillType: &quot;All&quot;,
                cellAutofillOption: {
                    directionX: true,
                    directionY: true,
                },
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                columns: [
                    { field: &quot;col1&quot;, key: &quot;col1&quot;, title: &quot;Col1&quot; },
                    { field: &quot;col2&quot;, key: &quot;col2&quot;, title: &quot;Col2&quot; },
                    { field: &quot;col3&quot;, key: &quot;col3&quot;, title: &quot;Col3&quot; },
                    { field: &quot;col4&quot;, key: &quot;col4&quot;, title: &quot;Col4&quot; },
                    { field: &quot;col5&quot;, key: &quot;col5&quot;, title: &quot;Col5&quot; },
                    { field: &quot;col6&quot;, key: &quot;col6&quot;, title: &quot;Col6&quot; },
                ],
                tableData: [],
            };
        },
        methods: {
            autofillTypeChang(type) {
                this.cellAutofillOption.directionX = false;
                this.cellAutofillOption.directionY = false;
                if (type === &quot;Horizontal&quot;) {
                    this.cellAutofillOption.directionX = true;
                } else if (type === &quot;Vertical&quot;) {
                    this.cellAutofillOption.directionY = true;
                } else if (type === &quot;All&quot;) {
                    this.cellAutofillOption.directionX = true;
                    this.cellAutofillOption.directionY = true;
                }
            },
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 8; i++) {
                    data.push({
                        rowKey: i,
                        col1: `A${i + 1}`,
                        col2: `B${i + 1}`,
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                        col8: `H${i + 1}`,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('el-radio-group',{on:{"change":_vm.autofillTypeChang},model:{value:(_vm.autofillType),callback:function ($$v) {_vm.autofillType=$$v},expression:"autofillType"}},[_c('el-radio',{attrs:{"label":"Horizontal"}},[_vm._v("Horizontal")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"Vertical"}},[_vm._v("Vertical")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"All"}},[_vm._v("All")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ve-table',{attrs:{"fixed-header":"","border-y":"","columns":_vm.columns,"table-data":_vm.tableData,"cell-autofill-option":_vm.cellAutofillOption,"rowKeyFieldName":"rowKey","rowStyleOption":_vm.rowStyleOption}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                autofillType: "All",
                cellAutofillOption: {
                    directionX: true,
                    directionY: true,
                },
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                columns: [
                    { field: "col1", key: "col1", title: "Col1" },
                    { field: "col2", key: "col2", title: "Col2" },
                    { field: "col3", key: "col3", title: "Col3" },
                    { field: "col4", key: "col4", title: "Col4" },
                    { field: "col5", key: "col5", title: "Col5" },
                    { field: "col6", key: "col6", title: "Col6" },
                ],
                tableData: [],
            };
        },
        methods: {
            autofillTypeChang(type) {
                this.cellAutofillOption.directionX = false;
                this.cellAutofillOption.directionY = false;
                if (type === "Horizontal") {
                    this.cellAutofillOption.directionX = true;
                } else if (type === "Vertical") {
                    this.cellAutofillOption.directionY = true;
                } else if (type === "All") {
                    this.cellAutofillOption.directionX = true;
                    this.cellAutofillOption.directionY = true;
                }
            },
            initTableData() {
                let data = [];
                for (let i = 0; i < 8; i++) {
                    data.push({
                        rowKey: i,
                        col1: `A${i + 1}`,
                        col2: `B${i + 1}`,
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                        col8: `H${i + 1}`,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  